export const userQueryKey = ['authenticated-user'] as const;

export const organizationQueryKey = ['organization'] as const;
